import { AutogenModelJobClass, AutogenRowJobClass } from "./autogen/AutogenModelJobClass";

export class ModelJobClass extends AutogenModelJobClass<RowJobClass> {
	constructor() {
		super(RowJobClass);
	}
}

export class RowJobClass extends AutogenRowJobClass {
}